import React from 'react';

const Skills = () => {
  // EASY UPDATE: Add or modify skills in these arrays
  const skillCategories = [
    {
      title: 'Cloud & Infrastructure',
      skills: [
        { name: 'AWS', level: 'Beginner' },
        { name: 'Networking', level: 'Certified' },
        { name: 'Linux', level: 'Advanced' },
        { name: 'Windows', level: 'Advanced' },
      ],
    },
    {
      title: 'Containers & Orchestration',
      skills: [
        { name: 'Docker', level: 'Beginner' },
        { name: 'Kubernetes', level: 'Beginner' },
      ],
    },
    {
      title: 'CI/CD & Automation',
      skills: [
        { name: 'Git', level: 'Intermediate' },
        { name: 'GitHub Actions', level: 'Intermediate' },
        { name: 'Bash', level: 'Intermediate' },
        { name: 'PowerShell', level: 'Intermediate' },
      ],
    },
    {
      title: 'Programming & Tools',
      skills: [
        { name: 'Python', level: 'Intermediate' },
        { name: 'JavaScript', level: 'Intermediate' },
        { name: 'Node.js', level: 'Intermediate' },
        { name: 'VS Code', level: 'Advanced' },
      ],
    },
  ];

  return (
    <section id="skills" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">Skills & Technologies</h2>
          <div className="w-20 h-1 bg-[#BCA4E3] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {skillCategories.map((category, index) => (
            <div key={index} className="bg-slate-900 border border-slate-800 p-6 rounded-lg hover:border-[#BCA4E3]/30 transition-colors">
              <h3 className="text-xl font-semibold text-white mb-6">{category.title}</h3>
              <div className="space-y-4">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="flex items-center justify-between">
                    <span className="text-slate-300 font-medium">{skill.name}</span>
                    <span className="text-sm text-slate-500">{skill.level}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
